export const countTypeOptions = [
  { value: "total", label: "Total" },
  { value: "daily", label: "Daily" },
];

export const categoryOptions = [
  { value: "HOT", label: "Hot" },
  { value: "WARM", label: "Warm" },
  { value: "COLD", label: "Cold" },
  { value: "SINGLE", label: "Single" },
  { value: "SUBSCRIPTION", label: "Subscription" }
];

export const leadSourceOptions = [
  { value: "EHC", label: "Free Consultation" },
  { value: "ASSESSMENT", label: "Assessment" },
];
export const graphOptions = [
  { value: "line", label: "Line Graph" },
  { value: "bar", label: "Bar Graph" },
];

export const platformOptions = [
  { value: "WEB", label: "Web" },
  { value: "APP", label: "App" },
];
